import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddAlertIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_alert"}/>
}
